<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical :headerTitle="`${pageTitle}`" :IsUseInnerAddition="true" :IsUseEditorBox="true" device="web">
        <template v-slot:innerAddition>
          <v-row no-gutters>
            <v-col cols="12" md="12">
              <v-text-field
                class="search-text-field mx-1"
                placeholder="통합 검색(이름, 직책)"
                dense
                outlined
                hide-details="auto"
                @change="changeInput"
              />
            </v-col>
          </v-row>
        </template>
        <template v-slot:EditorBox>
          <v-switch v-model="showUncheckedOnly" label="미확인 건만 보기" @change="switchChange()" />
        </template>
        <template v-slot:body>
          <v-expansion-panels v-model="expandedPanel" multiple flat class="worker-check-panels">
            <v-expansion-panel v-for="(row, i) in workerList" :key="row.esgHrNo + '_' + i" class="worker-check-panel">
              <v-expansion-panel-header v-bind:color="''" class="worker-check-panel-header">
                <div class="worker-check-header-inner d-flex justify-space-between align-center">
                  <span class="worker-check-title d-flex align-center flex-wrap">
                    <span class="worker-check-name">{{ row.korNm }}</span>
                    <v-divider vertical class="worker-check-divider mx-3" />
                    <span class="worker-check-auth">{{ row.grpAuthNm }}</span>
                    <span v-if="row.signatureYn === 'N'" class="worker-check-signature-alert d-flex align-center ml-3">
                      <svg-icon icon-class="check" class="worker-check-signature-icon" />
                      <span class="ml-1">서명 등록 필요</span>
                    </span>
                  </span>
                  <div class="worker-check-header-actions d-flex align-center flex-shrink-0">
                    <div class="worker-pending-count d-flex align-center mr-3">
                      <span class="worker-pending-count__label">미확인 건 수 :</span>
                      <span class="worker-pending-count__num" :class="{ 'worker-pending-count__num--alert': getUnCheckedCount(row) > 0 }">
                        {{ getUnCheckedCount(row) }}
                      </span>
                    </div>
                    <v-btn
                      class="worker-check-btn-batch"
                      color="info"
                      small
                      elevation="0"
                      :disabled="row.taskList.length === 0"
                      @click.stop="btnCheckAll(row)"
                    >
                      일괄 처리
                    </v-btn>
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="worker-check-panel-content">
                <v-divider class="mt-1" />
                <v-row no-gutters>
                  <v-col cols="12" v-if="row.taskList.length > 0">
                    <v-simple-table class="worker-check-table mt-4 custom-table">
                      <colgroup>
                        <col style="width: 5%" />
                        <col style="width: 5%" />
                        <col style="width: 30%" />
                        <col style="width: 35%" />
                        <col style="width: 15%" />
                        <col style="width: 10%" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td class="text-center tableTitle">번호</td>
                          <td class="text-center tableTitle">구분</td>
                          <td class="text-center tableTitle">제목</td>
                          <td class="text-center tableTitle">문서명</td>
                          <td class="text-center tableTitle">알림발송일</td>
                          <td class="text-center tableTitle">확인</td>
                        </tr>
                        <tr v-for="(task, index) in row.taskList" :key="index">
                          <td class="text-center">{{ index + 1 }}</td>
                          <td class="text-center">{{ task.type === 'sign' ? '서명' : '확인' }}</td>
                          <td>{{ task.title }}</td>
                          <td>{{ task.subTitle }}</td>
                          <td class="text-center">{{ task.createdAt }}</td>
                          <td class="text-center">
                            <v-btn
                              color="primary"
                              small
                              elevation="0"
                              @click="btnCheck(row, task)"
                              :disabled="task.type === 'sign' && row.signatureYn === 'N'"
                            >
                              {{ task.type === 'sign' ? '서명하기' : '확인하기' }}
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-col>
                  <v-col cols="12" v-else>
                    <div class="worker-check-empty d-flex justify-center align-center">
                      <span class="worker-check-empty__text">확인이 필요한 문서가 없습니다.</span>
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right headerTitle :useBtnList="buttonUseList" @btnSearch="btnSearch(true)"></i-card-right>
        <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button color="btn_text" :text="'일괄 처리'" :icon="'check'" :appendDivider="false" @click="btnCheckAll()"></i-icon-button>
          </template>
        </i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
// Components
import baseview from '@/views/base/baseview.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import iCardRight from '@/components/common/iCardRight.vue'
import { getWorkerCheckManage, saveWorkerCheckManage } from '@/api/procedure/workerCheckManage'

export default {
  mixins: [baseview, iCardRight],
  components: {
    'i-card-vertical': iCardVertical,
  },
  data() {
    return {
      pageTitle: '근로자 확인 관리',
      buttonUseList: [
        'btnSearch', // 조회
      ],
      originWorkerList: [], // 원본 데이터
      workerList: [], // 표시 데이터
      expandedPanel: [], // 펼침 상태
      searchKeyword: '', // 검색어
      showUncheckedOnly: false, // 모두 확인 여부
    }
  },
  computed: {},
  created() {},
  beforeMount() {},
  mounted() {
    this.btnSearch(true)
  },
  activated() {
    this.btnSearch(true)
  },
  methods: {
    getUnCheckedCount(row) {
      if (!row || !row.taskList) return 0
      return row.taskList.length
    },
    applyFilters() {
      const keyword = (this.searchKeyword ?? '').toString().trim()
      this.workerList = this.originWorkerList.filter((row) => {
        const korNm = (row?.korNm ?? '').toString()
        const grpAuthNm = (row?.grpAuthNm ?? '').toString()
        const hasUnchecked = (row?.taskList?.length ?? 0) > 0

        const keywordMatched = !keyword || korNm.includes(keyword) || grpAuthNm.includes(keyword)
        const uncheckedMatched = !this.showUncheckedOnly || hasUnchecked

        return keywordMatched && uncheckedMatched
      })
    },
    changeInput(e) {
      this.searchKeyword = e
      this.applyFilters()
    },
    switchChange() {
      this.applyFilters()
    },

    //////////////////////////////////////////////////////////////////////
    // 버튼 이벤트
    //////////////////////////////////////////////////////////////////////
    async btnSearch(isNotify) {
      this.openLoading()
      const param = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
      }
      getWorkerCheckManage(param, isNotify)
        .then((res) => {
          if (res.success) {
            this.originWorkerList = JSON.parse(JSON.stringify(res.list || []))
            this.applyFilters()
          }
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },

    /* 일괄 처리 버튼 클릭 */
    btnCheckAll(row) {
      if (row) {
        // 특정인원 일괄 처리 시
        const name = row.korNm + '(' + row.grpAuthNm + ')'
        const signatureYnText = row.signatureYn === 'Y' ? '' : '서명이 등록되지 않아 서명 처리는 제외됩니다.'
        this.vToastifyPrompt(`${name} 님의 미확인 문서를 일괄 처리하시겠습니까? </> ${signatureYnText}`, 'info', async (current) => {
          const param = row.signatureYn === 'Y' ? row.taskList : row.taskList.filter((task) => task.type === 'check')
          param.forEach((task) => {
            task.esgHrNo = row.esgHrNo
          })
          this.openLoading()
          saveWorkerCheckManage(param, true)
            .then((res) => {
              if (res.success) {
                this.btnSearch(false)
              }
            })
            .catch(() => {
              this.endLoading()
            })
            .finally(() => {
              this.endLoading()
            })
        })
      } else {
        // 전 인원 일괄 처리 시

        this.vToastifyPrompt(
          `현재 화면 인원의 미확인 문서를 일괄 처리하시겠습니까?<br/> 서명이 등록되지 않은 인원의 경우 서명 처리는 제외됩니다.`,
          'info',
          async (current) => {
            let param = _.cloneDeep(this.workerList)
            let saveData = []
            param.forEach((row) => {
              row.taskList = row.signatureYn === 'Y' ? row.taskList : row.taskList.filter((task) => task.type === 'check')
              row.taskList.forEach((task) => {
                task.esgHrNo = row.esgHrNo
              })
              saveData.push(...row.taskList)
            })
            console.log(saveData)
            this.openLoading()
            saveWorkerCheckManage(saveData, true)
              .then((res) => {
                if (res.success) {
                  this.btnSearch(false)
                }
              })
              .catch(() => {
                this.endLoading()
              })
              .finally(() => {
                this.endLoading()
              })
          }
        )
      }
    },
    /* 확인하기 버튼 클릭 */
    btnCheck(row, task) {
      const type = task.type === 'sign' ? '서명' : '확인'
      this.vToastifyPrompt(`${task.title} 문서를 ${type} 처리 하시겠습니까?`, 'info', async (current) => {
        task.esgHrNo = row.esgHrNo
        this.openLoading()
        saveWorkerCheckManage([task], true)
          .then((res) => {
            if (res.success) {
              this.btnSearch(false)
            }
          })
          .catch(() => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
          })
      })
    },
  },
}
</script>

<style scoped lang="scss">
.worker-check-panels {
  background: transparent;

  ::v-deep .v-expansion-panel {
    margin-bottom: 3px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(0, 0, 0, 0.06);

    &:last-child {
      margin-bottom: 0;
    }

    &::before {
      box-shadow: none;
    }
  }
}

.worker-check-panel-header {
  padding: 12px 16px;
  min-height: 52px;
}

.worker-check-header-inner {
  width: 100%;
  gap: 12px;
}

.worker-check-title {
  min-width: 0;
  font-size: 0.9375rem;
  line-height: 1.4;
}

.worker-check-name {
  color: rgba(0, 0, 0, 0.87);
  font-weight: 700;
  letter-spacing: -0.01em;
}

.worker-check-auth {
  color: rgba(0, 0, 0, 0.87);
  font-weight: 400;
  letter-spacing: -0.01em;
}

.worker-check-divider {
  align-self: stretch;
  opacity: 0.35;
}

.worker-check-signature-alert {
  color: #c62828;
  font-size: 0.8125rem;
  font-weight: 500;
}

.worker-check-signature-icon {
  height: 20px !important;
  width: 20px !important;
}

.worker-check-header-actions {
  gap: 4px;
}

.worker-pending-count {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.65);
}

.worker-pending-count__label {
  margin-right: 4px;
  white-space: nowrap;
}

.worker-pending-count__num {
  font-weight: 600;
  min-width: 1.25em;
  text-align: right;
  color: rgba(0, 0, 0, 0.6);
  transition: color 0.15s ease;
}

.worker-pending-count__num--alert {
  color: #c62828;
  font-weight: 700;
}

.worker-check-btn-batch {
  flex-shrink: 0;
}

.worker-check-panel-content {
  ::v-deep .v-expansion-panel-content__wrap {
    padding: 0 16px 16px;
  }
}

.worker-check-table {
  border-radius: 6px;
  overflow: hidden;
}

.worker-check-empty {
  min-height: 120px;
  padding: 24px 16px;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  border: 1px dashed rgba(0, 0, 0, 0.12);
}

.worker-check-empty__text {
  font-size: 0.9375rem;
  color: rgba(0, 0, 0, 0.45);
}
</style>
